import type { ReactNode } from 'react'

export interface ContextChatMessage {
  id: string
  role: 'user' | 'assistant'
  content: string
  state?: 'streaming' | 'failed'
}

export interface ContextChatPanelProps<Message extends ContextChatMessage> {
  title: string
  dialogLabel: string
  launcherLabel: string
  emptyTitle: string
  placeholder: string
  suggestions: string[]
  messages: Message[]
  draft: string
  isSending: boolean
  isLoadingHistory?: boolean
  isResetting?: boolean
  autoOpenStorageKey?: string
  notice?: string
  composerControls?: ReactNode
  showComposerContext?: boolean
  isInputDisabled?: boolean
  onMinimize?: () => void
  embedded?: boolean
  avatarSrc?: string
  headerActions?: ReactNode
  onDraftChange: (value: string) => void
  onSend: (suggestion?: string) => void
  onStop: () => void
  onCopy: () => void
  onReset: () => void
  renderMessage: (message: Message) => ReactNode
}

export const DESKTOP_MEDIA_QUERY = '(min-width: 1024px)'
